<template>
  <div v-loading="loading">
    <div class="title">挑战任务</div>
    <div class="search-box">
      <div>
        <CascaderPosition
          size="medium"
          :job-id.sync="job_id"
          @getNodes="handleGetJob"
        ></CascaderPosition>
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="截止日期"
          class="w-200 mr-12"
          size="medium"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button type="primary" size="medium" plain @click="handleSearch"
          >搜索</el-button
        >
        <el-button size="medium" @click="handleReset">重置</el-button>
      </div>
      <div>
        <el-link
          style="height: 100%"
          size="small"
          icon="el-icon-question"
          :underline="false"
          @click="openWay"
          >挑战设计指南</el-link
        >
      </div>
    </div>
    <el-table :data="list" :stripe="true">
      <el-table-column width="50" label="编号" prop="id"></el-table-column>
      <el-table-column width="" label="职业方向" prop="jobs">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.jobs" :key="index">
            {{ item.job_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        label="挑战名称"
        prop="name"
      ></el-table-column>
      <el-table-column width="140" label="已通过 / 任务总量">
        <template slot-scope="scope">
          {{ scope.row.challenge_passed_count }} /
          {{ scope.row.number }}
        </template>
      </el-table-column>
      <el-table-column width="130">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>任务单价</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.unit_price_min + ' ~ ' + scope.row.unit_price_max"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="140" label="任务截止时间" prop="end_at">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          {{ scope.row.end_at }}
        </template>
      </el-table-column>
      <el-table-column width="140" label="操作" prop="id">
        <template slot-scope="scope">
          <el-link
            size="small"
            @click="watchDetail(scope.row)"
            v-if="
              authPermissions.includes(
                'challenge_service.api.fuwu_admin.challenge_tasks.show'
              )
            "
            :underline="false"
            >详情</el-link
          >
          <el-divider direction="vertical"></el-divider>
          <el-link
            size="small"
            @click="handleCreate(scope.row.id)"
            v-if="
              authPermissions.includes(
                'challenge_service.api.fuwu_admin.my_challenges.store'
              )
            "
            :underline="false"
            >创建挑战</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
    <el-dialog :visible.sync="dialogVisible" width="1000px">
      <el-form :model="detailForm" label-width="120px">
        <el-form-item label="任务名称：">
          <div>{{ detailForm.name }}</div>
        </el-form-item>
        <el-form-item label="职业方向：">
          <div v-for="item in detailForm.jobs" :key="item.job_id">
            {{ item.job_name }}
          </div>
        </el-form-item>
        <el-form-item label="创建时间：">{{
          detailForm.created_at
        }}</el-form-item>
        <el-form-item label="截止时间：">{{ detailForm.end_at }}</el-form-item>
        <el-form-item label="任务总量：">{{ detailForm.number }}</el-form-item>
        <el-form-item label="任务单价："
          >{{ detailForm.unit_price_min }} -
          {{ detailForm.unit_price_max }} 元</el-form-item
        >
        <el-form-item label="任务详细说明：">
          <Markdown
            :value.sync="detailForm.description"
            :disabled="true"
          ></Markdown
        ></el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import challengeService from "@/global/service/challenge";
import CascaderPosition from "./widgets/CascaderPosition.vue";
import ShowHideContent from "@/components/ShowHideContent";
import Markdown from "@/components/Markdown";
import { mapState } from "vuex";
export default {
  components: {
    CascaderPosition,
    ShowHideContent,
    Markdown
  },
  data() {
    return {
      loading: false,
      options: [],
      searchLoading: false,
      select: null,
      date: null,
      list: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      job_id: null,
      isShow: false,
      dialogVisible: false,
      content: "",
      detailForm: {}
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        end_at: this.date,
        job_id: this.job_id
      };
      challengeService
        .challengeTaskList(params)
        .then(res => {
          res.list.forEach(data => {
            data.end_at = data.end_at.substring(0, 10);
          });
          this.list = res.list;
          this.pagination.currentPage = res.pagination.current_page;
          this.pagination.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleRemote() {},
    watchDetail(detail) {
      this.detailForm = detail;

      this.dialogVisible = true;
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.job_id = null;
      this.date = null;
      this.getData();
    },
    openWay() {
      window.open("https://jiker.feishu.cn/docs/doccn0UBWua6alGesoLiZkVUQgg");
    },
    goPage(current) {
      this.pagination.currentPage = current;
      this.$router.push({
        name: "ChallengeTaskSelf",
        query: {
          page: current
        }
      });
    },
    handleCreate(id) {
      this.$router.push({
        name: "ChallengeCreate",
        params: {
          id
        }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    handleGetJob(e) {
      this.job_id = e[0]?.value;
    }
  }
};
</script>
<style lang="less" scoped>
.search-box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
.el-icon-view {
  margin-left: 3px;
}
.dialog-content {
  display: flex;
  padding-bottom: 20px;
  padding-right: 10px;
  .dialog-label {
    width: 120px;
    text-align: right;
    margin-right: 10px;
  }
  .dialog-desc {
  }
}
</style>
